import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SellerProfileState {
  currentStep: number;
  changePercentage: number;
}

const initialState: SellerProfileState = {
  currentStep: 0,
  changePercentage: 0,
};

export const sellerProfileSlice = createSlice({
  name: 'sellerProfile',
  initialState,
  reducers: {
    incrementCurrentStep: (state) => {
      state.currentStep += 1;
    },
    decrementCurrentStep: (state) => {
      state.currentStep -= 1;
    },
    setCurrentStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    resetCurrentStep: (state) => {
      state.currentStep = 0;
    },
    triggerChangePercentage: (state) => {
      state.changePercentage += 1;
    },
  },
});

export const {
  incrementCurrentStep,
  decrementCurrentStep,
  setCurrentStep,
  resetCurrentStep,
  triggerChangePercentage,
} = sellerProfileSlice.actions;

export default sellerProfileSlice.reducer;
